import styled from "@emotion/styled"

import { rhythm } from "@utils/typography"

const Wrapper = styled.header`
  background: ${props => props.theme.backgroundColor};
  padding: ${rhythm(1 / 2)} 0;
  z-index: 1000;
`

const Logo = styled.img`
  display: inline-block;
  margin-bottom: 0;
  margin-right: ${rhythm(1 / 2)};
`

const Toggle = styled.button`
  background: none;
  border: none;
  &:hover,
  &:focus {
    cursor: pointer;
  }
`

export { Logo, Toggle, Wrapper }
